import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { GenericLinkComponent } from './generic-link.component';

@NgModule({
  declarations: [GenericLinkComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [GenericLinkComponent],
})
export class GenericLinkModule {}
